import { VocabularyCard } from './VocabularyCard';
export default VocabularyCard;
